import store from '../store';
import cartItemListMixin from '../vue_mixins/cartItemListMixin';
import i18n from "../vue_i18n";

if($('#shopping-cart-popup').length > 0) {
    window.vm = new Vue({
        el: '#shopping-cart-popup',
        store,
        i18n,
        mixins: [cartItemListMixin],
        methods: {

        },
        created() {
            this.$store.dispatch('sessionOrder/getSessionOrder') // dispatch loading
        },
    });
}


